import can from 'can';

const priority = ['CUT', 'MC', 'WD', 'DQ'];
export function getSortResult(aValue, bValue, sortAsc) {
    let res = 0;
    res = Number(aValue) - Number(bValue);
    if (Number.isNaN(res)) {
        res = String(aValue).localeCompare(String(bValue));
    }

    return sortAsc ? res : res * -1;
}

export function getSortingFunc(sortKey, sortAsc, sortingField) {
    return (a, b) => {
        let aValue = a.attr(sortingField) || '-';
        let bValue = b.attr(sortingField) || '-';

        if (aValue === '-') {
            return 1;
        }
        if (bValue === '-') {
            return -1;
        }

        // specific logic for position, rank fields
        if (['pos', 'rank'].includes(sortingField)) {
            const aPos = String(aValue).replace(/\D/g, '');
            const bPos = String(bValue).replace(/\D/g, '');

            if (!aPos) {
                aValue = priority.indexOf(aValue) + 999;
            } else {
                aValue = aPos;
            }
            if (!bPos) {
                bValue = priority.indexOf(bValue) + 999;
            } else {
                bValue = bPos;
            }
        }

        // additional sorting by rank on equal round values
        if (aValue === bValue) {
            if (sortingField === 'pos') {
                aValue = a.attr('totalScore') || 0;
                bValue = b.attr('totalScore') || 0;
            } else {
                aValue = a.attr('rank') ? a.attr('rank') : 0;
                bValue = b.attr('rank') ? b.attr('rank') : 0;
            }
        }

        return getSortResult(aValue, bValue, sortAsc);
    };
}

export function updateComparator(viewModel, attrName) {
    const data = viewModel.attr(attrName);
    if (data) {
        can.batch.start();
        const sortKey = viewModel.attr('sortKey');
        const sortAsc = viewModel.attr('sortAsc');
        data.attr(
            'comparator',
            getSortingFunc(
                sortKey,
                sortAsc,
                viewModel.getSortingField(sortKey),
            ),
        );
        can.batch.stop();
    }
}
